import { FC, useContext } from 'react';

import { Table } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';

import { ITableBlockProps } from '../interface';
import s from './TableBlock.module.scss';
import { useColumns } from './useColumns';

export const TableBlock: FC<ITableBlockProps> = ({
  data,
  loading,
  apiCalled,
  type,
}) => {
  const { t } = useContext(LocalizationContext);
  const COLUMNS = useColumns(type, data);

  return (
    <div className={cn(s.wrapper, data.length === 100 && s.bottom_placeholder)}>
      <Table
        data={data}
        columns={COLUMNS}
        isLoading={loading}
        emptyDataPlaceholder={t(
          apiCalled ? 'report.placeholder' : 'report.placeholder.emptyDates'
        )}
        className={s.table}
      />
      {data.length === 100 && (
        <div className={s.placeholder}>
          {t('applicationsReport.table.footer')}
        </div>
      )}
    </div>
  );
};
